const actionTypes = require('constants/actionTypes');
const Immutable = require('immutable');

const setInitialState = () => {
    return Immutable.Map().merge({
        batchError: false,
    });
};

const initialState = setInitialState();

const errorReducer = (state, action) => {
    state = state || initialState;

    if (action.type === actionTypes.BATCH_ERROR) {
        const batchError = action.data;

        return state.merge({
            batchError,
        });
    } else {
        return state;
    }
};

module.exports = errorReducer;
